














import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import PreviewType from '@/components/map/controls/PreviewType.vue'
import { ViewType, ViewTypeValue } from '@/interfaces/ViewType'
import { map } from '@/store/modules'
import { BaseMap } from '@/utils/map'

@Component({
  components: { PreviewType }
})
export default class ViewMode extends Vue {
  @Prop({ default: 'scan' })
  value: ViewTypeValue

  open = false
  types: ViewType[] = [
    BaseMap.SCAN,
    BaseMap.SATELLITE,
    BaseMap.MONDE
  ]

  get currentType (): ViewType | null {
    return map.viewType
  }

  set currentType (value: ViewType | null) {
    map.applyViewType(value)
  }

  typeClicked (type: ViewType) {
    if (type === this.currentType) {
      this.open = !this.open
    } else {
      this.currentType = type
      this.$emit('input', this.currentType.type)
      this.open = false
    }
  }

  @Watch('value', { immediate: true })
  onValueChanged (newVal: ViewTypeValue) {
    const newType = this.types.find(td => td.type === newVal) || this.types[0]
    if (newType !== this.currentType) {
      this.currentType = newType
    }
  }
}
